// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"f5623731","100":"b4d508dd","164":"f33863eb","172":"66e9b379","186":"15a33739","681":"c4d9383c","872":"bafa0b8b","894":"b0ba60ab","945":"9f19c01a"}[chunkId] + ".chunk.js";
};